import React from 'react';
import {inject, observer} from 'mobx-react';

import './style/';
import E9Header from './E9Header';
import E9LeftMenu from './E9LeftMenu';

@inject('portalThemeStore')
@observer
class E9Theme extends React.Component {
    constructor(props) {
        super(props);
        this.widthChange = this.widthChange.bind(this);
    }

    componentDidMount() {
        const {portalThemeStore, location} = this.props;
        const {pathname, query} = location;
        portalThemeStore.getTopMenu(pathname, query);
        window.addEventListener('resize',this.widthChange);
    }

    componentWillUnmount(){
        window.removeEventListener('resize',this.widthChange);
    }
    widthChange =() => {       
        const logo= $('.e9header-left').width();
        const rleft=$('.e9header-right-menu').width();
        const rright=$('.e9header-right-toolbar').width();
        const topswitch=$('.e9header-switch').width();
        const wid=logo+rleft+rright+topswitch+30;
        $('.e9theme-layout-container').css({'min-width':wid+'px'})
        $('.e9theme-layout2-container').css({'min-width':wid+'px'});
        $('.e9theme-layout3-container').css({'min-width':wid+'px'});
        $('.e9theme-layout4-container').css({'min-width':wid+'px'});
    }


    render() {
        const {portalThemeStore, location} = this.props;
        const {searchParams, themeInfo} = portalThemeStore;
        const {themeColorType} = themeInfo;
        const colorClassName = themeColorType ? `e9theme-color-${themeColorType}` : '';
        const {query} = location;
        const {hideHeader = query.hideHeader, hideAside = query.hideAside} = searchParams;
        return (
            <div className={`e9theme-layout-container ${colorClassName}`}>
                {
                    hideHeader == 'true' ? null : (
                        <div className="e9theme-layout-header">
                            <E9Header {...this.props} />
                        </div>
                    )
                }
                <div className="e9theme-layout-content" style={hideHeader == 'true' ? {top: 0} : {}}>
                    <div id="themeLayoutMask" className="e9theme-layout-mask"></div>
                    {
                        hideAside == 'true' ? null : (
                            <div className="e9theme-layout-aside">
                                <E9LeftMenu {...this.props} />
                            </div>
                        )
                    }
                    <div className="e9theme-layout-main" style={hideHeader == 'true' && hideAside == 'true' ? {padding: 0} : {}}>
                        <div id="themeLayoutRoute" className="e9theme-layout-route">
                            {this.props.children}
                        </div>
                        <div id="themeLayoutFrame" className="e9theme-layout-frame">
                            <iframe id="mainFrame" name="mainFrame" src="about:blank"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default E9Theme;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/index.js